import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { IoChevronBack, IoChevronUp } from "react-icons/io5";

import * as S from "./styles";
import FrontCreditoIcon from "../../assets/navbar/Front_Credito_on_light_blue.svg";
import User from "../../assets/navbar/Usuario_on.svg";
import Navbar from "../../components/Navbar";
import ListViewProposal from "./detail/resumo";
import OperationComponent from "./detail/operacao";
import CadastroComponent from "./detail/cadastro";
import RelacionamentoComponent from "./detail/relacionamento";
import GarantiaComponent from "./detail/garantia";
import AnaliseCreditoComponent from "./detail/analisecredito";
import HeaderItem from "./subcomponents/HeaderItem";
import {
  RESUMO,
  OPERACAO,
  CADASTRO,
  RELACIONAMENTO,
  GARANTIA,
  ANALISE_CREDITO,
} from "./pages";
import Button from "../../components/Button-v2";
import { Grid } from "@mui/material";

import {
  loadOrderSummaryAndPaymentTypes,
  loadProposalOperation,
  loadFluxoConsolidado,
  loadConsultaSCR,
  loadFluxoModalidade,
  loadAggregates,
  loadProposalCompleteRegistration,
  loadProposalPartnershipRegistrations,
  loadParticipacoesOutrasEmpresas,
  loadClienteContas,
  loadVendaDireta,
  loadClienteAtrasoFinanceira,
  loadNotaFiscal,
  loadOpinionTypes,
  loadOpinions,
  loadProposalPossibleStatuses,
  loadEventTypesV2,
  loadEvents,
  loadEventsV2,
  loadProposalWarrantyVehicleInfo,
  loadResumoPropostas,
  loadProposalWarrantyGuarantors,
  loadAnotherOrderValues,
  loadVehiclesOnExchange,
  loadRejectionOpinions,
} from "./service";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

const ViewCreditProposal = () => {
  const history = useHistory();
  const [selected, setSelected] = useState(RESUMO);

  const { proposalNumber, cpfCnpj } = useParams();

  const [proposalOperation, setProposalOperation] = useState({});
  const [proposalOperationLoading, setProposalOperationLoading] =
    useState(true);
  const [orderSummary, setOrderSummary] = useState({});
  const [orderSummaryLoading, setOrderSummaryLoading] = useState(true);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(true);
  const [proposalInfoWarranty, setProposalInfoWarranty] = useState({});
  const [proposalInfoWarrantyLoading, setProposalInfoWarrantyLoading] =
    useState(true);
  const [proposalWarrantyGuarantors, setProposalWarrantyGuarantors] = useState(
    {}
  );
  const [
    proposalWarrantGuarantorsOtherCompanies,
    setProposalWarrantGuarantorsOtherCompanies,
  ] = useState([]);
  const [
    proposalWarrantGuarantorsCustomerAccounts,
    setProposalWarrantGuarantorsCustomerAccounts,
  ] = useState([]);
  const [
    proposalWarrantyGuarantorsLoading,
    setProposalWarrantyGuarantorsLoading,
  ] = useState(true);
  const [proposalWarrantyVehicleInfo, setProposalWarrantyVehicleInfo] =
    useState({});
  const [
    proposalWarrantyVehicleInfoLoading,
    setProposalWarrantyVehicleInfoLoading,
  ] = useState(true);
  const [proposalFluxoConsolidado, setProposalFluxoConsolidado] = useState([]);
  const [proposalFluxoConsolidadoLoading, setProposalFluxoConsolidadoLoading] =
    useState(true);
  const [proposalConsultaSCR, setProposalConsultaSCR] = useState({});
  const [proposalConsultaSCRLoading, setProposalConsultaSCRLoading] =
    useState(true);
  const [proposalFluxoModalidade, setProposalFluxoModalidade] = useState([]);
  const [proposalFluxoModalidadeLoading, setProposalFluxoModalidadeLoading] =
    useState(true);
  const [otherProposals, setOtherProposals] = useState({});
  const [otherProposalsLoading, setOtherProposalsLoading] = useState(true);
  const [aggregates, setAggregates] = useState({});
  const [aggregatesLoading, setAggregatesLoading] = useState(true);
  const [operationTotalValue, setOperationTotalValue] = useState(0);
  const [proposalCompleteRegistration, setProposalCompleteRegistration] =
    useState();
  const [
    proposalCompleteRegistrationLoading,
    setProposalCompleteRegistrationLoading,
  ] = useState(true);
  const [
    proposalPartnershipRegistrations,
    setProposalPartnershipRegistrations,
  ] = useState();
  const [
    proposalPartnershipRegistrationsLoading,
    setProposalPartnershipRegistrationsLoading,
  ] = useState(true);
  const [participacoesOutrasEmpresas, setParticipacoesOutrasEmpresas] =
    useState();
  const [
    participacoesOutrasEmpresasLoading,
    setParticipacoesOutrasEmpresasLoading,
  ] = useState(true);
  const [clienteContas, setClienteContas] = useState();
  const [clienteContasLoading, setClienteContasLoading] = useState(true);
  const [vendaDireta, setVendaDireta] = useState();
  const [vendaDiretaLoading, setVendaDiretaLoading] = useState(true);
  const [vendaDiretaTotal, setVendaDiretaTotal] = useState();
  const [pageVendaDireta, setPageVendaDireta] = useState();
  const [clienteAtrasoFinanceira, setClienteAtrasoFinanceira] = useState();
  const [clienteAtrasoFinanceiraLoading, setClienteAtrasoFinanceiraLoading] =
    useState();

  const [anotherOrderValues, setAnotherOrderValues] = useState();
  const [anotherOrderValuesLoading, setAnotherOrderValuesLoading] = useState();
  const [vehiclesOnExchange, setVehiclesOnExchange] = useState();
  const [vehiclesOnExchangeLoading, setVehiclesOnExchangeLoading] = useState();

  const [notaFiscal, setNotaFiscal] = useState();
  const [notaFiscalLoading, setNotaFiscalLoading] = useState(true);
  const [notaFiscalTotal, setNotaFiscalTotal] = useState();
  const [pageNotaFiscal, setPageNotaFiscal] = useState();

  const [resumoPropostas, setResumoPropostas] = useState();
  const [resumoPropostasLoading, setResumoPropostasLoading] = useState(true);

  const [eventTypesV2, setEventTypesV2] = useState([]);
  const [eventTypesV2Loading, setEventTypesV2Loading] = useState(true);
  const [opinionTypes, setOpinionTypes] = useState([]);
  const [opinionTypesLoading, setOpinionTypesLoading] = useState(true);
  const [proposalPossibleStatuses, setProposalPossibleStatuses] = useState([]);
  const [proposalPossibleStatusesLoading, setProposalPossibleStatusesLoading] =
    useState(true);

  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [eventsV2, setEventsV2] = useState([]);
  const [eventsV2Loading, setEventsV2Loading] = useState(true);
  const [opinions, setOpinions] = useState([]);
  const [opinionsLoading, setOpinionsLoading] = useState(true);

  const [filtersVendaDireta, setFiltersVendaDireta] = useState({
    cpfCnpj: cpfCnpj,
    pageable: {
      page: 0,
      size: 10,
      sortColumn: null,
      sortDirection: "ASC",
    },
  });
  const [filtersNotaFiscal, setFiltersNotaFiscal] = useState({
    cpfCnpj: cpfCnpj,
    pageable: {
      page: 0,
      size: 10,
      sortColumn: null,
      sortDirection: "ASC",
    },
  });

  const [rejectionOpinions, setRejectionOpinions] = useState([]);
  const [rejectionOpinionsLoading, setRejectionOpinionsLoading] =
    useState(true);

  useEffect(() => {
    // Nota Fiscal
    loadNotaFiscal(filtersNotaFiscal, {
      setNotaFiscal,
      setNotaFiscalLoading,
      setNotaFiscalTotal,
      setPageNotaFiscal,
    });
  }, [filtersNotaFiscal]);

  useEffect(() => {
    // Venda Direta
    loadVendaDireta(filtersVendaDireta, {
      setVendaDireta,
      setVendaDiretaLoading,
      setVendaDiretaTotal,
      setPageVendaDireta,
    });
  }, [filtersVendaDireta]);

  useEffect(() => {
    if (proposalNumber) {
      loadRejectionOpinions(
        { proposalNumber },
        {
          setRejectionOpinions,
          setRejectionOpinionsLoading,
        }
      );
    }
  }, [proposalNumber]);

  useEffect(() => {
    loadData(proposalNumber, cpfCnpj);
  }, [proposalNumber, cpfCnpj]);

  async function loadData(proposalNumber, cpfCnpj) {
    const params = { proposalNumber, cpfCnpj };
    //Pedido Resumo
    loadOrderSummaryAndPaymentTypes(params, {
      setOrderSummary,
      setOrderSummaryLoading,
      setPaymentTypes,
      setPaymentTypesLoading,
      setOperationTotalValue,
    });
    //Dados Operacao e Info Garantia
    loadProposalOperation(params, {
      setProposalOperation,
      setProposalOperationLoading,
      setProposalInfoWarranty,
      setProposalInfoWarrantyLoading,
    });
    //Fluxo Consolidado
    loadFluxoConsolidado(params, {
      setProposalFluxoConsolidado,
      setProposalFluxoConsolidadoLoading,
    });
    //Consulta SCR
    loadConsultaSCR(params, {
      setProposalConsultaSCR,
      setProposalConsultaSCRLoading,
    });
    //Fluxo Modalidade
    loadFluxoModalidade(params, {
      setProposalFluxoModalidade,
      setProposalFluxoModalidadeLoading,
    });
    //Agregados
    loadAggregates(params, { setAggregates, setAggregatesLoading });
    // Proposta Cadastro Completo
    loadProposalCompleteRegistration(params, {
      setProposalCompleteRegistration,
      setProposalCompleteRegistrationLoading,
    });
    // Proposta Cadastro Sócios
    loadProposalPartnershipRegistrations(params, {
      setProposalPartnershipRegistrations,
      setProposalPartnershipRegistrationsLoading,
    });
    // Participações outras empresas
    loadParticipacoesOutrasEmpresas(params, {
      setParticipacoesOutrasEmpresas,
      setParticipacoesOutrasEmpresasLoading,
    });
    // Informações financeiras
    loadClienteContas(params, { setClienteContas, setClienteContasLoading });
    // Atrasos Financeira
    loadClienteAtrasoFinanceira(params, {
      setClienteAtrasoFinanceira,
      setClienteAtrasoFinanceiraLoading,
    });
    // Tipos parecer
    loadOpinionTypes({ setOpinionTypes, setOpinionTypesLoading });
    // Pareceres
    loadOpinions(params, { setOpinions, setOpinionsLoading });
    // Possiveis Status Proposta
    loadProposalPossibleStatuses(params, {
      setProposalPossibleStatuses,
      setProposalPossibleStatusesLoading,
    });
    // Tipos evento v2
    loadEventTypesV2({
      setEventTypes: setEventTypesV2,
      setEventTypesLoading: setEventTypesV2Loading,
    });
    // Eventos
    loadEvents(params, { setEvents, setEventsLoading });
    // Eventos v2
    loadEventsV2(params, {
      setEvents: setEventsV2,
      setEventsLoading: setEventsV2Loading,
    });
    //Dados Veículos Garantia
    loadProposalWarrantyVehicleInfo(params, {
      setProposalWarrantyVehicleInfo,
      setProposalWarrantyVehicleInfoLoading,
    });
    //Resumo de propostas
    loadResumoPropostas(params, {
      setResumoPropostas,
      setResumoPropostasLoading,
    });
    //Dados Avalistas Garantia
    loadProposalWarrantyGuarantors(params, {
      setProposalWarrantyGuarantors,
      setProposalWarrantyGuarantorsLoading,
      setProposalWarrantGuarantorsOtherCompanies,
      setProposalWarrantGuarantorsCustomerAccounts,
    });
    //Outros valores da proposta
    loadAnotherOrderValues(params, {
      setAnotherOrderValues,
      setAnotherOrderValuesLoading,
    });
    //Veículos na troca
    loadVehiclesOnExchange(params, {
      setVehiclesOnExchange,
      setVehiclesOnExchangeLoading,
    });
  }

  const reloadEvents = () => {
    loadEvents({ cpfCnpj, proposalNumber }, { setEvents, setEventsLoading });
  };

  const reloadEventsV2 = () => {
    loadEventsV2(
      { cpfCnpj, proposalNumber },
      { setEvents: setEventsV2, setEventsLoading: setEventsV2Loading }
    );
  };

  const reloadCombinedEvents = () => {
    reloadEvents();
    reloadEventsV2();
  };

  const eventsCombined = [
    ...(events || []).map((item) => ({ ...item, origem: "SGS" })),
    ...(eventsV2 || []).map((item) => ({ ...item, origem: "Financeira" })),
  ].sort((firstEvent, secondEvent) => {
    const firstDate = firstEvent?.dataEvento
      ? new Date(firstEvent.dataEvento).getTime()
      : 0;
    const secondDate = secondEvent?.dataEvento
      ? new Date(secondEvent.dataEvento).getTime()
      : 0;

    return secondDate - firstDate;
  });

  const eventsCombinedLoading = eventsLoading || eventsV2Loading;

  const reloadOpinions = () => {
    loadOpinions(
      { cpfCnpj, proposalNumber },
      { setOpinions, setOpinionsLoading }
    );
  };

  const reloadProposalPossibleStatuses = () => {
    loadProposalPossibleStatuses(
      { proposalNumber },
      { setProposalPossibleStatuses, setProposalPossibleStatusesLoading }
    );
  };

  const renderPage = () => {
    switch (selected) {
      case OPERACAO:
        return (
          <OperationComponent
            proposalOperation={proposalOperation}
            proposalOperationLoading={proposalOperationLoading}
            proposalInfoWarranty={proposalInfoWarranty}
            proposalInfoWarrantyLoading={proposalInfoWarrantyLoading}
            proposalWarrantyVehicleInfo={proposalWarrantyVehicleInfo}
            aggregates={aggregates}
            aggregatesLoading={aggregatesLoading}
            proposalCompleteRegistration={proposalCompleteRegistration}
            operationTotalValue={operationTotalValue}
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            paymentTypes={paymentTypes}
            paymentTypesLoading={paymentTypesLoading}
          />
        );
      case CADASTRO:
        return (
          <CadastroComponent
            cpfCnpj={cpfCnpj}
            proposalOperation={proposalOperation}
            proposalOperationLoading={proposalOperationLoading}
            proposalCompleteRegistration={proposalCompleteRegistration}
            proposalPartnershipRegistrations={proposalPartnershipRegistrations}
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            proposalPartnershipRegistrationsLoading={
              proposalPartnershipRegistrationsLoading
            }
            participacoesOutrasEmpresas={participacoesOutrasEmpresas}
            participacoesOutrasEmpresasLoading={
              participacoesOutrasEmpresasLoading
            }
            clienteContas={clienteContas}
            clienteContasLoading={clienteContasLoading}
          />
        );
      case RELACIONAMENTO:
        return (
          <RelacionamentoComponent
            proposalOperation={proposalOperation}
            proposalOperationLoading={proposalOperationLoading}
            vendaDireta={vendaDireta}
            vendaDiretaLoading={vendaDiretaLoading}
            vendaDiretaTotal={vendaDiretaTotal}
            pageVendaDireta={pageVendaDireta}
            filtersVendaDireta={filtersVendaDireta}
            setFiltersVendaDireta={setFiltersVendaDireta}
            clienteAtrasoFinanceira={clienteAtrasoFinanceira}
            clienteAtrasoFinanceiraLoading={clienteAtrasoFinanceiraLoading}
            notaFiscal={notaFiscal}
            notaFiscalLoading={notaFiscalLoading}
            notaFiscalTotal={notaFiscalTotal}
            pageNotaFiscal={pageNotaFiscal}
            filtersNotaFiscal={filtersNotaFiscal}
            setFiltersNotaFiscal={setFiltersNotaFiscal}
            proposalCompleteRegistration={proposalCompleteRegistration}
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            resumoPropostas={resumoPropostas}
            resumoPropostasLoading={resumoPropostasLoading}
            otherProposals={otherProposals}
            otherProposalsLoading={otherProposalsLoading}
            cpfCnpj={cpfCnpj}
            proposalNumber={proposalNumber}
          />
        );
      case GARANTIA:
        return (
          <GarantiaComponent
            proposalOperation={proposalOperation}
            proposalOperationLoading={proposalOperationLoading}
            proposalWarrantGuarantorsCustomerAccounts={
              proposalWarrantGuarantorsCustomerAccounts
            }
            proposalWarrantGuarantorsOtherCompanies={
              proposalWarrantGuarantorsOtherCompanies
            }
            proposalWarrantyGuarantors={proposalWarrantyGuarantors}
            proposalWarrantyGuarantorsLoading={
              proposalWarrantyGuarantorsLoading
            }
            proposalWarrantyVehicleInfo={proposalWarrantyVehicleInfo}
            proposalWarrantyVehicleInfoLoading={
              proposalWarrantyVehicleInfoLoading
            }
            proposalCompleteRegistration={proposalCompleteRegistration}
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
          />
        );
      case ANALISE_CREDITO:
        return (
          <AnaliseCreditoComponent
            cpfCnpj={cpfCnpj}
            proposalNumber={proposalNumber}
            proposalCompleteRegistration={proposalCompleteRegistration}
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            proposalOperation={proposalOperation}
            proposalOperationLoading={proposalOperationLoading}
            proposalInfoWarranty={proposalInfoWarranty}
            proposalFluxoModalidade={proposalFluxoModalidade}
            otherProposals={otherProposals}
            eventTypes={eventTypesV2}
            eventTypesLoading={eventTypesV2Loading}
            events={eventsCombined}
            eventsLoading={eventsCombinedLoading}
            opinionTypes={opinionTypes}
            opinionTypesLoading={opinionTypesLoading}
            proposalPossibleStatuses={proposalPossibleStatuses}
            proposalPossibleStatusesLoading={proposalPossibleStatusesLoading}
            opinions={opinions}
            opinionsLoading={opinionsLoading}
            reloadEvents={reloadCombinedEvents}
            reloadOpinions={reloadOpinions}
            reloadProposalPossibleStatuses={reloadProposalPossibleStatuses}
            rejectionOpinions={rejectionOpinions}
          />
        );
      case RESUMO:
      default:
        return (
          <ListViewProposal
            proposalOperation={proposalOperation}
            proposalOperationLoading={proposalOperationLoading}
            orderSummary={orderSummary}
            orderSummaryLoading={orderSummaryLoading}
            paymentTypes={paymentTypes}
            paymentTypesLoading={paymentTypesLoading}
            operationTotalValue={operationTotalValue}
            proposalInfoWarranty={proposalInfoWarranty}
            proposalInfoWarrantyLoading={proposalInfoWarrantyLoading}
            proposalFluxoConsolidado={proposalFluxoConsolidado}
            proposalFluxoConsolidadoLoading={proposalFluxoConsolidadoLoading}
            proposalConsultaSCR={proposalConsultaSCR}
            proposalConsultaSCRLoading={proposalConsultaSCRLoading}
            proposalFluxoModalidade={proposalFluxoModalidade}
            proposalFluxoModalidadeLoading={proposalFluxoModalidadeLoading}
            proposalCompleteRegistration={proposalCompleteRegistration}
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            proposalWarrantyGuarantors={proposalWarrantyGuarantors}
            proposalWarrantyGuarantorsLoading={
              proposalWarrantyGuarantorsLoading
            }
            anotherOrderValues={anotherOrderValues}
            anotherOrderValuesLoading={anotherOrderValuesLoading}
            vehiclesOnExchange={vehiclesOnExchange}
            vehiclesOnExchangeLoading={vehiclesOnExchangeLoading}
            cpfCnpj={cpfCnpj}
            proposalNumber={proposalNumber}
          />
        );
    }
  };

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={FrontCreditoIcon} />
            <div>
              <S.Title>Front de Crédito</S.Title>
              <S.Description>Visualizar proposta</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>
        <S.Tabs>
          <HeaderItem
            onClick={setSelected}
            value={RESUMO}
            active={selected === RESUMO}
            icon={User}
          />
          <HeaderItem
            onClick={setSelected}
            value={OPERACAO}
            active={selected === OPERACAO}
            icon={User}
          />
          <HeaderItem
            onClick={setSelected}
            value={CADASTRO}
            active={selected === CADASTRO}
            icon={User}
          />
          <HeaderItem
            onClick={setSelected}
            value={RELACIONAMENTO}
            active={selected === RELACIONAMENTO}
            icon={User}
          />
          <HeaderItem
            onClick={setSelected}
            value={GARANTIA}
            active={selected === GARANTIA}
            icon={User}
          />
          <HeaderItem
            onClick={setSelected}
            value={ANALISE_CREDITO}
            active={selected === ANALISE_CREDITO}
            icon={User}
          />
        </S.Tabs>
        {renderPage()}
        <Grid container spacing={2}>
          <Grid item xs>
            <S.GoBackButtonWrapper>
              <Button
                onClick={() => history.push("/front-de-credito")}
                height="32px"
                leftIcon={IoChevronBack}
              >
                Voltar
              </Button>
            </S.GoBackButtonWrapper>
          </Grid>
          <Grid item xs>
            <GoTopoButtonWrapper>
              <Button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                height="32px"
                leftIcon={IoChevronUp}
              >
                Topo
              </Button>
            </GoTopoButtonWrapper>
          </Grid>
        </Grid>
      </S.Wrapper>
    </>
  );
};

export default ViewCreditProposal;
